import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import { VueMasonryPlugin } from "vue-masonry";
import liff from "@line/liff";
import { useStore } from "./store/SessionLiffStore";
import "./assets/style/main.scss";
import "./assets/style/tailwind.scss";
import "./index.css";
import { liffId } from "./consts/common";
import { configure } from "vee-validate";
import { localize, setLocale } from "@vee-validate/i18n";
import ja from "@vee-validate/i18n/dist/locale/ja.json";
import { setLocale as yupSetLocale } from "yup";
import { suggestive } from "yup-locale-ja/cjs";
import { createSentryPiniaPlugin } from "@sentry/vue";
// import { LiffMockPlugin } from "@line/liff-mock";

const app = createApp(App);
const pinia = createPinia();
pinia.use(createSentryPiniaPlugin());

configure({
  generateMessage: localize({
    ja,
  }),
});

import * as Sentry from "@sentry/vue";

Sentry.init({
  app,
  dsn: "https://946160c4eb59fe272837e7e03fbe9c71@o11267.ingest.us.sentry.io/4508039193165824",
  environment:
    process.env.NODE_ENV == "development" ? "development" : "production",
  // environment: "production", // 本番
  // environment: "development", // ローカル
  integrations: [
    Sentry.vueIntegration({
      tracingOptions: {
        trackComponents: true,
        hooks: ["activate", "create", "unmount", "mount", "update"],
      },
    }),
    Sentry.browserTracingIntegration({ router }),
  ],
  tracesSampleRate: 0.1,
});

setLocale("ja");
yupSetLocale(suggestive);
// if (process.env.NODE_ENV == "development") {
//   liff.use(new LiffMockPlugin());
// }

liff.init({
  liffId: liffId, // Use own liffId
  withLoginOnExternalBrowser: true, // Enable automatic login process
});
liff.ready.then(async () => {
  document.title = "OMOT Influencer";
  // LINEからしか開けないよう制御
  if (liff.isLoggedIn() && liff.isInClient()) {
    // if (liff.isLoggedIn()) {
    const userId = (await liff.getProfile()).userId;
    if (!userId) Sentry.captureMessage("userIdがない");

    app.use(router).use(VueMasonryPlugin).use(pinia).mount("#app");
    const store = useStore();
    if (liff.getAccessToken()) {
      store.setAccessToken(liff.getAccessToken());
      if (!localStorage.getItem("liffToken")) {
        localStorage.setItem("liffToken", liff.getAccessToken());
      }
    }
    store.setLineUserId(userId);
  }
});
